export enum RecipientTypes {
  None = 0,
  Company = 1,
  Borrower = 2,
  Lender = 3,
  Holder = 4,
}
